
import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const AlertModal = ({ children, show, toggle }) => (
  <Modal isOpen={show} toggle={toggle}>
    <ModalHeader toggle={toggle}>Error</ModalHeader>
    <ModalBody>
      {children}
    </ModalBody>
    <ModalFooter>
      {/* <Button color="primary" onClick={toggle}>Do Something</Button>{' '} */}
      <Button color="secondary" onClick={toggle}>OK</Button>
    </ModalFooter>
  </Modal>
);

export default AlertModal;
